import e, { Component as t } from "react";
import n from "../../../../node_modules/classnames/index.js";
import "../../../utils/DomHandler.js";
import r from "../../../utils/ObjectUtils.js";
import { Ripple as o } from "../../forms/Ripple/Ripple.js";
function a(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function i(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function u(e, t) {
  return (u = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var s = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && u(e, t);
  }(m, t);
  var s,
    c,
    f,
    g = (s = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        n = l(m);
      if (s) {
        var r = l(this).constructor;
        t = Reflect.construct(n, arguments, r);
      } else t = n.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : a(this);
    });
  function m() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, m), e = g.apply(this, arguments), i(a(e), "isActive", function (t) {
      return t - 1 === e.props.page;
    }), i(a(e), "shouldTruncateList", function () {
      return e.props.value.length > 0 && e.props.value[e.props.value.length - 1] !== e.props.pageCount - 1;
    }), e;
  }
  return c = [{
    key: "onPageLinkClick",
    value: function value(e, t) {
      this.props.onClick && this.props.onClick({
        originalEvent: e,
        value: t
      }), e.preventDefault();
    }
  }, {
    key: "render",
    value: function value() {
      var t,
        a = this;
      if (this.props.value) {
        var p = this.props.value[0],
          i = this.props.value[this.props.value.length - 1];
        t = this.props.value.map(function (t) {
          var l,
            u = n("paginator__page paginator__element link", {
              "paginator--page-start": t === p,
              "paginator--page-end": t === i,
              "paginator--highlight": t - 1 === a.props.page
            });
          if (l = e.createElement("button", {
            className: u,
            onClick: function onClick(e) {
              return a.onPageLinkClick(e, t);
            },
            type: "button"
          }, t, e.createElement(o, null)), a.props.template) {
            var s = {
              onClick: function onClick(e) {
                return a.onPageLinkClick(e, t);
              },
              className: u,
              view: {
                startPage: p - 1,
                endPage: i - 1
              },
              page: t - 1,
              currentPage: a.props.page,
              totalPages: a.props.pageCount,
              element: l,
              props: a.props
            };
            l = r.getJSXElement(a.props.template, s);
          }
          return e.createElement(e.Fragment, {
            key: t
          }, l);
        });
      }
      return e.createElement("span", {
        className: "paginator__pages"
      }, t, this.shouldTruncateList() && e.createElement("span", {
        className: "paginator__page paginator__page--disabled"
      }, "..."), e.createElement("span", {
        className: n("paginator__page", {
          "paginator__page--active": this.isActive(this.props.pageCount)
        }),
        onClick: function onClick(e) {
          return a.onPageLinkClick(e, a.props.pageCount);
        }
      }, this.props.pageCount, e.createElement(o, null)));
    }
  }], p(m.prototype, c), f && p(m, f), m;
}(t);
i(s, "defaultProps", {
  value: null,
  page: null,
  rows: null,
  pageCount: null,
  links: null,
  template: null
});
export { s as PageLinks };